import React from "react";

export default function ErrorText({ hasError }: { hasError: string }) {
  const textColor = hasError ? "#e5484d" : "#84828e";

  return (
    <div style={{ color: textColor, fontSize: "14px" }}>
      <span>{hasError} </span>
    </div>
  );
}
